export * from './src/restaurants-menus-v1-item-modifier-item-modifiers.meta.js';
